// extracted by mini-css-extract-plugin
module.exports = {"item":"footer-cta_item__25hj8","footer":"footer-cta_footer__2b56o","element":"footer-cta_element__236Dz","link":"footer-cta_link__2YaGu"};